exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".thing-form {\n  margin: 20px 0; }\n\n#banner {\n  border-bottom: none;\n  margin-top: -20px; }\n", "", {"version":3,"sources":["/Users/jean-philippe/_work/rs-webapp/rs-lightbox-old/client/app/layout/main/main.scss"],"names":[],"mappings":"AAAA;EACE,eAAe,EAAE;;AAEnB;EACE,oBAAoB;EACpB,kBAAkB,EAAE","file":"main.scss","sourcesContent":[".thing-form {\n  margin: 20px 0; }\n\n#banner {\n  border-bottom: none;\n  margin-top: -20px; }\n"],"sourceRoot":""}]);

// exports
